import React from 'react';

const DropdownDivider: React.FC = () => (
  <li><div className="dropdown-divider mx-3 h-25"></div></li>
);

export default DropdownDivider;
